import type { ArticleSection } from '@/mocks/news';

interface ArticleContentProps {
  sections: ArticleSection[];
}

export default function ArticleContent({ sections }: ArticleContentProps) {
  return (
    <div className="flex flex-col gap-5">
      {sections.map((section, index) => {
        const key = `${section.type}-${index}`;

        if (section.type === 'heading') {
          return (
            <h2
              key={key}
              id={`section-${index}`}
              className="mt-2 flex items-center gap-2.5 font-heading text-xl font-bold text-foreground-950 md:text-2xl"
            >
              <span className="h-5 w-1.5 rounded-full bg-accent-500"></span>
              {section.text}
            </h2>
          );
        }

        if (section.type === 'paragraph') {
          return (
            <p key={key} className="text-[15px] leading-8 text-foreground-700">
              {section.text}
            </p>
          );
        }

        if (section.type === 'list') {
          return (
            <ul key={key} className="flex flex-col gap-2.5 rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
              {(section.items ?? []).map((item) => (
                <li key={item} className="flex items-start gap-2.5 text-[15px] leading-7 text-foreground-700">
                  <i className="ri-checkbox-circle-fill mt-1 text-primary-500"></i>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          );
        }

        if (section.type === 'image') {
          return (
            <figure key={key} className="overflow-hidden rounded-lg border border-background-200">
              <div className="relative w-full h-56 md:h-80">
                <img
                  src={section.url}
                  alt={section.caption ?? '原神游戏截图'}
                  className="absolute inset-0 h-full w-full object-cover object-top"
                />
              </div>
              {section.caption && (
                <figcaption className="bg-background-100 px-4 py-2.5 text-center text-xs text-foreground-500">
                  {section.caption}
                </figcaption>
              )}
            </figure>
          );
        }

        if (section.type === 'tip') {
          return (
            <div
              key={key}
              className="flex items-start gap-3 rounded-lg border border-accent-200 bg-accent-50 p-4 md:p-5"
            >
              <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-accent-500 text-white">
                <i className="ri-lightbulb-line"></i>
              </span>
              <div>
                <p className="text-sm font-semibold text-accent-900">小贴士</p>
                <p className="mt-1 text-sm leading-7 text-foreground-700">{section.text}</p>
              </div>
            </div>
          );
        }

        return null;
      })}
    </div>
  );
}